import { Descriptions as AntdDescriptions } from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Descriptions from "../../general/antd/descriptions";
import PageDetails from "../../general/details";
import { useNavigate, useParams } from "react-router-dom";
import Spin from "../../general/antd/spin";
import AppContext from "../../../context/app/context";
import UnitPartitionContext from "../../../context/unit-partition/context";
import UnitPartitionContextProvider from "../../../context/unit-partition/provider";

const UnitPartition: React.FC = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const { details, actions, loading } = useContext(UnitPartitionContext);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    id && actions.getDetails(Number(id));
  }, [direction]);

  return (
    <PageDetails
      title={t("details")}
      subtitle={t("unit_partition_details")}
      buttonName={t("update_unit_partition")}
      onClick={() => navigate(`/unit-partitions/update/${id}`)}
      loading={loading.includes('details')}
      onRefresh={() => actions.getDetails(Number(id))}
    >
      {loading.includes("details") ? (
        <Spin />
      ) : (
        <Descriptions size="small" column={1} bordered>
          <AntdDescriptions.Item label={t("id")}>
            {details?.id}
          </AntdDescriptions.Item>
          <AntdDescriptions.Item label={t("name")}>
            {details?.name ?? "-"}
          </AntdDescriptions.Item>
          <AntdDescriptions.Item label={t("note")}>
            {details?.note ?? "-"}
          </AntdDescriptions.Item>
          <AntdDescriptions.Item label={t("percentage")}>
            {details?.percentage ?? "-"}
          </AntdDescriptions.Item>
          <AntdDescriptions.Item label={t("unit_id")}>
            {details?.unit.name ?? "-"}
          </AntdDescriptions.Item>
        </Descriptions>
      )}
    </PageDetails>
  );
};

const UnitPartitionDetailsPage = () => {
  return (
    <UnitPartitionContextProvider>
      <UnitPartition />
    </UnitPartitionContextProvider>
  );
};

export default UnitPartitionDetailsPage;